import { render, staticRenderFns } from "./LeftMenuCampus.vue?vue&type=template&id=313a9243&scoped=true"
import script from "./LeftMenuCampus.vue?vue&type=script&lang=js"
export * from "./LeftMenuCampus.vue?vue&type=script&lang=js"
import style0 from "./LeftMenuCampus.vue?vue&type=style&index=0&id=313a9243&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313a9243",
  null
  
)

export default component.exports